import script from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./SvgIcon.vue?vue&type=script&setup=true&lang=js"

import "./SvgIcon.vue?vue&type=style&index=0&id=52778488&scoped=true&lang=css"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52778488"]])

export default __exports__